module.exports = __webpack_public_path__ + "static/garmin_run_coach-6dc6326fcf67b2beba575ac60faa81a6.jpg";